import { render, staticRenderFns } from "./AdminOrderBadge.vue?vue&type=template&id=46ec6809"
import script from "./AdminOrderBadge.vue?vue&type=script&lang=js"
export * from "./AdminOrderBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ec6809')) {
      api.createRecord('46ec6809', component.options)
    } else {
      api.reload('46ec6809', component.options)
    }
    module.hot.accept("./AdminOrderBadge.vue?vue&type=template&id=46ec6809", function () {
      api.rerender('46ec6809', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminOrderBadge.vue"
export default component.exports